import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType"
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { ChangeEvent } from "../../code/library-ts/browser/events/ChangeEvent";
import { Rokojori } from "../Rokojori";
import { UserData } from "./RokojoriUser";

export class UserIcon
{
  static readonly type = new ElementType<HTMLElement>( "user-icon" );
  static readonly userShortName = new ElementType<HTMLElement>( "user-short-name" );

  static _icons:HTMLElement[] = [];
  static _initialized = false;

  static applyOnDocument()
  {
    UserIcon.initialize();
    this._icons = [];
    UserIcon.type.forAllInDoc( e => UserIcon.applyOnElement( e ) );
    let user = Rokojori.$.userSystem;
    
    this.setUserStatus( user.isLoggedIn, user.userName );
  }

  static initialize()
  {
    if ( UserIcon._initialized )
    {
      return;
    }

    UserIcon._initialized = true;

    Rokojori.$.userSystem.userID.addListener( 
      async ( userToken:ChangeEvent<string> )=> 
      {
        //console.log( "user", userData );

        let hasUser = Rokojori.$.userSystem.isLoggedIn ;
        let name = ! hasUser ? "" : Rokojori.$.userSystem.userName;

        this.setUserStatus( hasUser, name );  
      }
    );
  }

  static applyOnElement( e:HTMLElement )
  {
    this._icons.push( e );
  }

  static setUserStatus( hasUser:boolean, userName:string )
  {
    this._icons.forEach( i => UserIcon._updateUserIconElement( i, hasUser, userName ) )
  }

  private static _updateUserIconElement( e:HTMLElement, hasUser:boolean, userName:string = null )
  {
    //console.log( "Setting", e, e.getAttribute( "class" ), hasUser );

    let userNameElement = UserIcon.userShortName.query( e );

    if ( userNameElement == null )
    {
      //console.log( "No user name found:", e );
      return;
    }

    let shortName = this.getShortName( userName );
    HTMLEditor.setText( userNameElement, shortName || "" ); 

    
  }

  private static getShortName( userName:string )
  {
    if ( userName == null )
    {
      return "-";
    }

    if ( userName.length == 2 )
    {
      return userName;
    }

    

    let firstAnyNextAny = /\b([a-zA-ZäöüÄÖÜ]).*?([a-zA-ZäöüÄÖÜ])/;
    let result = firstAnyNextAny.exec( userName );
    
    if ( result )
    {
      return ( result[ 1 ] + result[ 2 ] ).toUpperCase();
    }

    let firstAny = /\b([a-zA-ZäöüÄÖÜ])/;
    result = firstAny.exec( userName );

    if ( result )
    {
      return result[ 0 ];
    }

    
    return userName.substring( 0, 2 );

  }



}